import {fileExtension} from '../file_utils.ts';

const NET_SEARCH_DISABLED_EXTENSIONS = new Set(['kicad_sch', 'schdoc', 'prj']);

export function isAltiumSchematic(path: string): boolean {
  return fileExtension(path).toLowerCase() === 'schdoc';
}

/**
 * Returns true for schematic formats (KiCad, Altium) where net search
 * should be suppressed in the component search UI. Includes .prj because
 * multi-page project views use the project file path as headPath.
 *
 * An Altium project is not among them: converting the project file yields every
 * page and a project-wide `nets` map giving each net its name, which is what
 * searching a net across a design needs.
 */
export function isNetSearchDisabledSchematic(path: string): boolean {
  return NET_SEARCH_DISABLED_EXTENSIONS.has(fileExtension(path).toLowerCase());
}
